export function formatAdProviderIds(campaigns) {
  if (!Array.isArray(campaigns)) return '';
  const seen = new Set();
  const ordered = [];
  for (const c of campaigns) {
    const id = c && c.adProviderId;
    if (typeof id !== 'string' || id.length === 0) continue;
    if (seen.has(id)) continue;
    seen.add(id);
    ordered.push(id);
  }
  return ordered.join(', ');
}

export default formatAdProviderIds;
